/**
 * The theme contract for `SelectionRow` / `SelectionList`
 * (docs/solution-design/12-shared-selection-componentry.md §2.3–§3).
 *
 * Every visual the row draws comes from here, never from literals in the component — that is the
 * whole point: one shared component, per-brand visual language. Lives in its own module (not
 * theme.ts) so the component can import the defaults as a no-provider fallback without a
 * components ↔ theme import cycle.
 */
export interface SelectionRowVars {
  /** Vertical padding inside a row. */
  paddingBlock: string;
  /** Horizontal padding inside a row — also the indicator↔text gap. */
  paddingInline: string;
  /** Never below the 44px touch minimum (`size.touchMin`). */
  minHeight: string;
  /** Gap between rows in a `SelectionList`. */
  gap: string;
  radius: string;
  borderWidth: string;
  /** Row background when selected — a palette path (e.g. `primary.light`), resolved via `sx`. */
  selectedBackground: string;
  /** Default selection affordance; a call site may still override per list. */
  indicator: 'checkbox' | 'radio' | 'none';
}

/**
 * **Checkd as-built** — the values its `SelectableToggleButton` selection rows render today
 * (owner constraint C1, 2026-07-31: Checkd's visual identity does not move). A brand that
 * declares nothing gets exactly these; Trackd opts into its denser `--trackd-*` ramp in
 * theme.ts.
 */
export const SELECTION_ROW_DEFAULTS: SelectionRowVars = {
  paddingBlock: '12px',
  paddingInline: '16px',
  minHeight: '44px',
  gap: '16px',
  radius: '16px', // = BorderRadiusPx, Checkd's row radius
  borderWidth: '1px',
  selectedBackground: 'primary.light',
  indicator: 'radio',
};
